module.exports = __webpack_public_path__ + "static/media/logo_brcomerce_250x250.774a2909.svg";